// import {ACTION_TYPES} from "../../../core/consts";
// import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";
import {WebsiteModuleState} from "../../../apps/website/models/website-module.state";
// import {EntitiesRequestParams} from "../../../domain/entities/models/entities.request-params";
// import {EntitiesResponseDomainModel} from "../../../domain/entities/models/entities.response-domain-model";
import type {GameCenterContainerState} from "../models/game-center-container.state";
// import {EntitiesRequestParams} from "../../../domain/entities/models/entities.request-params";
import {ACTION_TYPES} from "../../../core/consts";
import {FetchHandler} from "../../../infrastructure/handlers/fetch-handler";
import {EntitiesDomainService} from "../../../domain/entities/services/entities.domain-service";
import {EntitiesRequestParams} from "../../../domain/entities/models/entities.request-params";
import {EntitiesResponseDomainModel} from "../../../domain/entities/models/entities.response-domain-model";
import {CompetitionDomainModel} from "../../../domain/common/competition/models/competition-domain-model";
// import type {CompetitorDomainModel} from "../../../domain/common/competitor/models/competitor-domain-model";
// import {NEW_COMPETITOR_CONTAINER} from "../game-center-container.consts";

export class GameCenterContainerFetchHandler extends FetchHandler {
  state: GameCenterContainerState;

  static injectables = [EntitiesDomainService, WebsiteModuleState];

  constructor(service: EntitiesDomainService, websiteModuleState) {
    super(service);

    this.websiteModuleState = websiteModuleState;
  }

  async onLoaded(): Promise<*> {
    super.onLoaded();

    this.action()
  }

  get requestParams(): EntitiesRequestParams {
    const entityId: Array<Number> = this.state.competitionId;

    let requestParams = new EntitiesRequestParams([entityId], null, null, null, true);

    return requestParams;
  }

  async action() {
    this.store.clearDataSource();

    const dataSource: EntitiesResponseDomainModel = await super.fetch();

    this.controller.action(ACTION_TYPES.populateData, {dataSource}).then(() => {
      const competition: CompetitionDomainModel = dataSource?.competitions?.find((competition: CompetitionDomainModel) => competition.id === this.state.competitionId);
      this.state.competition = competition;
      this.websiteModuleState.entitiesContext.setCompetition(competition);
    });

    return dataSource;
  }

  async onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    const isCompetitionKeyChanged: Boolean = prevProps.match.params.competitionKey !== nextProps.match.params.competitionKey;

    if (isCompetitionKeyChanged) {
      await this.action();
    }
  }
}